/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampDto } from '../../models/camp-dto';
import { CampShowResponse } from '../../models/camp-show-response';

export interface PostCampCreate$Params {
      body: CampDto
}

export function postCampCreate(http: HttpClient, rootUrl: string, params: PostCampCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postCampCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampShowResponse>;
    })
  );
}

postCampCreate.PATH = '/v1/camp';
